export { default } from './Header';

export const HEADER_HEIGHT = 100;